import Skeleton from "@mui/material/Skeleton";

const MarketSkeleton = () => {
  return (
    <>
      <div className="right_wrap market_wrap_main">
        <div className="mkt_skl_header">
          <div className="mkt_skl_top_wrap">
            <Skeleton variant="rectangular" className="mkt_skl_tab" />
            <Skeleton variant="rectangular" className="mkt_skl_tab" />
            <Skeleton variant="rectangular" className="mkt_skl_tab" />
            <Skeleton variant="rectangular" className="mkt_skl_tab" />
          </div>
          <div className="mkt_skl_rgt_wrap">
            <Skeleton variant="rectangular" className="mkt_skl_rgt" />
            <Skeleton variant="rectangular" className="mkt_skl_rgt" />
          </div>
        </div>
        <div className="market_tab_content">
          <div className="dsh_inv_grid market_card_row">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="dsh_inv_card">
                <div className="dsh_inv_head">
                  <div className="dsh_inv_top">
                    <Skeleton variant="text" className="dsh_skl_card_title" />
                  </div>
                  <Skeleton
                    variant="rectangular"
                    className="dsh_skl_card_img"
                  />
                  <Skeleton variant="text" className="dsh_skl_card_subtitle" />
                  <Skeleton variant="text" className="dsh_skl_card_subcnt" />
                  <div className="mt-3">
                    <div className="dsh_inv_cd_flx">
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                    </div>
                    <div className="dsh_inv_cd_flx mt-3">
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                      <div className="dsh_inv_cd_lft">
                        <span>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl"
                          />
                        </span>
                        <h4>
                          <Skeleton
                            variant="text"
                            className="dsh_skl_card_lbl_cnt"
                          />
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <Skeleton variant="text" className="dsh_skl_card_btn" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketSkeleton;
